export default "/assets/images/graph-virus.f4f730b0b4e7351f.png";